export default {
  mnemonic: '',
  encryptedMnemonic: '',
  pathDerivation: "m/44'/60'/0'/0/0",
  pendingAction: null,
  pendingActionDescription: null,
  pendingPayload: null,
  userBalance: 0,
  userQrCode: '',
  metaMaskAddress: ''
}
